import m from "../../../../geodata/es2015/region/usa/wiLow";
window.am4geodata_region_usa_wiLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/wiLow.js
// module id = null
// module chunks = 